import React from 'react';
import { AccordionItemProvider } from '../AccordionItemContext';
import styles from './AccordionGroup.module.scss';

type Props = {
  children: JSX.Element | JSX.Element[];
  className?: string;
  initiallyOpen?: boolean;
};

export const AccordionGroup = ({
  children,
  className,
  initiallyOpen = false,
  ...props
}: Props) => {
  const classes = [styles.AccordionGroup];
  if (className) classes.push(className);

  return (
    <AccordionItemProvider initiallyOpen={initiallyOpen}>
      <div className={classes.join(' ')} {...props}>
        {children}
      </div>
    </AccordionItemProvider>
  );
};
